module.exports = __webpack_public_path__ + "img/analitica_icon_white.0f4e83af.svg";